export default __webpack_public_path__ + "static/media/support.b1b60bae.svg";